module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.config,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "类型",
      "prop": "type"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.deal_time.type),
      expression: "curInput.deal_time.type"
    }],
    staticClass: "h-40 w-200",
    attrs: {
      "placeholder": "请选择类型"
    },
    domProps: {
      "value": (_vm.curInput.deal_time.type)
    },
    on: {
      "input": function($event) {
        _vm.curInput.deal_time.type = $event
      }
    }
  }, _vm._l((_vm.typeOptions), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "最小单位",
      "prop": "unit"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.deal_time.unit),
      expression: "curInput.deal_time.unit"
    }],
    staticClass: "h-40 w-200",
    attrs: {
      "placeholder": "请选择最小单位"
    },
    domProps: {
      "value": (_vm.curInput.deal_time.unit)
    },
    on: {
      "input": function($event) {
        _vm.curInput.deal_time.unit = $event
      }
    }
  }, _vm._l((_vm.unitOptions), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8267050e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Model/configComponents/dealtimeConfig.vue
// module id = 1947
// module chunks = 2